import { render, staticRenderFns } from "./OtherPartyNpr.vue?vue&type=template&id=2a7896a0&scoped=true"
import script from "./OtherPartyNpr.vue?vue&type=script&lang=ts"
export * from "./OtherPartyNpr.vue?vue&type=script&lang=ts"
import style0 from "./OtherPartyNpr.vue?vue&type=style&index=0&id=2a7896a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7896a0",
  null
  
)

export default component.exports